<title class="text-danger ">BHP </title>
<h2 class="text-danger strong m-5 text-center">Oops! Something went wrong . Please try again later</h2>
